<template>
    <div>
        <report-dialog
            v-model="showDialog"
            :report="selected"
        />

        <div class="pl-3">
            <v-expansion-panels
                v-if="groups"
                focusable
                accordion
                class="pb-2"
            >
                <v-expansion-panel v-for="(group,index) in groups" :key="index">
                    <v-expansion-panel-header
                        hide-actions
                        style="min-height: 35px;"
                    >
                        {{ group.name }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-list-item class="pa-0  pt-0 pb-0 ml-0" v-for="report in group.reports" :key="report.id" link @click="onReport(report)">
                           <v-list-item-title  class="pr-0 ml-0 v-flex"  style="font-size: 14px; font-weight: 400; padding-left: 0px; padding-top: 0!important; padding-bottom: 0!important;" >
                               <div style="font-size: 38px; padding-left: 12px;">&#8227;</div>
                               <div style="padding-left: 4px; padding-top: 12px;">{{ report.name }}</div>
                           </v-list-item-title>
                        </v-list-item>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>

import ReportDialog from "@/modules/rep/components/ReportDialog";

export default {
    name: "ReportList",

    components: {
        ReportDialog

    },

    props: {
        show: {

        },

        area: {

        },

        format: {

        }
    },

    data: () => ({
        showDialog: false,
        selected  : null,
        groups    : {}
    }),

    computed: {
        reports () {
            return this.$store.getters.reportDefinitions.filter(r => r.group.area === this.area && r.format.id === this.format);
        }
    },

    watch: {
        show () {
            if (!this.show) {
                this.showDialog = false;
            }
        }
    },

    mounted() {
        this.groups = {};
        this.reports.forEach(report => {
            let groups = this.groups [report.group.id];
            if (!groups) {
                groups = {
                    name   : report.group.name,
                    reports: [],
                };
                this.groups [report.group.id] = groups;
            }

            groups.reports.push(report);
        })
    },

    methods: {
        onReport (report) {
            this.selected = report;
            this.showDialog = true;
        }
    }
}
</script>

<style scoped>

.report-item a {
    color: white;
    font-size: 10pt;
}

::v-deep .v-expansion-panel-content__wrap {
    padding-left: 0px!important;
    padding-right: 0px!important;
}

::v-deep .v-expansion-panel-content {
    width: calc(100% + 10px)!important;
    font-weight: 300!important;
}

::v-deep .v-expansion-panel-header {
    padding-left: 15px!important;
    padding-right: 0;
}

::v-deep .v-list-item {
    padding-left: 5px!important;
    margin-left: 0;
}

::v-deep .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:hover::before, .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active::before {
    opacity: 0.2;
}

</style>